const utils = {

  getLoginInfo() {
    return JSON.parse(localStorage.getItem("KODEROVER_LOGIN_INFO"));
  },

  saveLoginInfo(data) {
    localStorage.setItem("KODEROVER_LOGIN_INFO", JSON.stringify(data));
  },

  clearLoginInfo() {
    localStorage.clear();
  },

  cloneObj(obj) {
    var str,
      newobj = obj.constructor === Array ? [] : {};
    if (typeof obj !== "object") {
      return;
    } else if (window.JSON) {
      (str = JSON.stringify(obj)), (newobj = JSON.parse(str));
    } else {
      for (var i in obj) {
        newobj[i] = typeof obj[i] === "object" ? cloneObj(obj[i]) : obj[i];
      }
    }
    return newobj;
  },

  formatTime(ms, showMin = false) {
    let date = new Date(ms);
    let year = date.getFullYear();
    let month = (date.getMonth() + 1 + "").padStart(2, 0);
    let day = (date.getDate() + "").padStart(2, 0);
    let hour = (date.getHours() + "").padStart(2, 0);
    let minute = (date.getMinutes() + "").padStart(2, 0);
    if (showMin) {
      return `${year}-${month}-${day} ${hour}:${minute}`;
    }
    return `${year}-${month}-${day}`;
  },

  getWeek(ms) {
    let wd = new Date(ms).getDay(),
      week = "";
    switch (wd) {
      case 0:
        week = "周日";
        break;
      case 1:
        week = "周一";
        break;
      case 2:
        week = "周二";
        break;
      case 3:
        week = "周三";
        break;
      case 4:
        week = "周四";
        break;
      case 5:
        week = "周五";
        break;
      case 6:
        week = "周六";
        break;
    }
    return week;
  }
};

export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js